export const CPF_LENGTH_WITHOUT_MASK = 11

export const CNPJ_LENGTH_WITHOUT_MASK = 14
